<template>
  <div class="mb-12 d-flex align-center gap-12">
    <section class="flex-shrink-0 font-20 font-w-500">
      <span>ตัวกรอง :</span>
    </section>
    <section class="d-flex scroll-filter">
      <div
        v-for="(item, index) in items"
        :key="`product-${index}`"
        class="mr-3 btn-tags-filter flex-shrink-0"
      >
        <span>สินค้า :</span>
        <span class="font-w-500 px-3">{{ item.class_name }}</span>
        <img
          src="/img/icons/icon-close-red.svg"
          width="25px"
          class="ml-5"
          @click="toggleItem(item)"
        />
      </div>

      <div
        v-for="(item, index) in itemsBrand"
        :key="`brand-${index}`"
        class="mr-3 btn-tags-filter flex-shrink-0"
      >
        <span>Brand :</span>
        <span class="font-w-500 px-3">{{ item.name }}</span>
        <img
          src="/img/icons/icon-close-red.svg"
          width="25px"
          class="ml-5"
          @click="toggleItemBrand(item)"
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['items', 'itemsBrand'],

  methods: {
    toggleItem(item) {
      this.$emit('toggle', item)
    },

    toggleItemBrand(item) {
      this.$emit('toggleBrand', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-tags-filter {
  border: 1px solid #a50200;
  border-radius: 9px;
  background-color: #fff1f1;
  padding: 10px 15px;
  color: #a50200;
}

.scroll-filter {
  overflow-y: auto;
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.scroll-filter::-webkit-scrollbar {
  display: none;
}
</style>
